import React, { ReactElement } from "react";
import * as app from "../services/AppService"; 
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";


interface CheckboxProps extends RowItem, Omit<InterfaceComponentsProps,"Icon">  {
    onChange?: (checked: boolean, key: string | undefined) => any;
    model: boolean;
    elmKey?: string | number;
    class?: string; 
}

export default function Checkbox(props: CheckboxProps): ReactElement {
    const inputId = props.id || props.label;

    function handler(event: { target: { checked: boolean } }) {
        const { checked } = event.target;
        if (props.onChange && typeof props.onChange == "function")
            props.onChange(checked, props.elmKey?.toString());
    }

    let labelTag = <label htmlFor={inputId} className={"ms-2 form-check-label text-primary-emphasis user-select-none c-pointer " + props.labelClass}>
        {app.translate(props.label)}
    </label>;

    let input = (
        <input
            type="checkbox"
            name={inputId}
            id={inputId}
            key={props.elmKey}
            disabled={props.disabled}
            className="form-check-input"
            onChange={handler}
            checked={props.model}
        />
    );

    let IsAr = app.getCookie("language", "en") === "ar";
    return (
        <div className={props.isTable ? "" : `form-check ${props.class}`}>
            {IsAr ? input : labelTag}
            {IsAr ? labelTag : input}
        </div>
    );
}

Checkbox.defaultProps = {
    class: "",
    checkClass: "mt-1",
    name: "",
    label: "",
    isTable: false,
    disabled: false,
    className:''
};
